import type { ReactNode, RefObject, UIEventHandler } from 'react'
import { PageHeader } from './PageHeader'
import '../../styles/workspace.css'

type ShellProps = {
  title: string
  description?: ReactNode
  aside?: ReactNode
  footer?: ReactNode
  children: ReactNode
  className?: string
}

/** 对话、检索等全高工作区布局（侧栏 + 主区 + 可选底栏） */
export function WorkspaceShell({ title, description, aside, footer, children, className }: ShellProps) {
  return (
    <div className={`workspace-root${className ? ` ${className}` : ''}`}>
      <div className="workspace-card">
        {aside}
        <main className="workspace-main" style={aside ? undefined : { width: '100%' }}>
          <header className="workspace-main-head">
            <PageHeader title={title} description={description} />
          </header>
          <div className="workspace-scroll">{children}</div>
          {footer != null && <footer className="workspace-composer">{footer}</footer>}
        </main>
      </div>
    </div>
  )
}

type AsideProps = {
  title: string
  action?: ReactNode
  children: ReactNode
  listRef?: RefObject<HTMLDivElement | null>
  onListScroll?: UIEventHandler<HTMLDivElement>
}

/** 工作区左侧栏（历史对话等） */
export function WorkspaceAside({ title, action, children, listRef, onListScroll }: AsideProps) {
  return (
    <aside className="workspace-aside">
      <div className="workspace-aside-head">
        <p className="workspace-aside-title">{title}</p>
        {action}
      </div>
      <div className="workspace-aside-list" ref={listRef} onScroll={onListScroll}>
        {children}
      </div>
    </aside>
  )
}
